/**
 * boton-compra-fijo.js
 * Sticky add-to-cart que dispara el mismo formulario y lógica
 * que el botón principal de la ficha de producto.
 */

(function () {
  function initStickyATC(root) {
    root = root || document;

    var productSection =
      root.querySelector('.product-section[data-section-type="product"]') ||
      root.querySelector('[data-section-type="product"]') ||
      root.querySelector('.ProductMain');

    if (!productSection) return;

    var sticky = productSection.querySelector('[data-boton-compra-fijo]');
    if (!sticky) return;

    if (sticky.dataset.bcfInitialized === 'true') return;
    sticky.dataset.bcfInitialized = 'true';

    var stickyButton = sticky.querySelector('[data-boton-compra-fijo-button]');
    var stickyPrice = sticky.querySelector('[data-boton-compra-fijo-price]');

    var productForm =
      productSection.querySelector('form[action*="/cart/add"]') ||
      productSection.querySelector('form[data-product-form]') ||
      productSection.querySelector('form');

    var mainButton = productForm
      ? productForm.querySelector(
          '[data-add-to-cart], .ProductForm__AddToCart, button[name="add"], button[type="submit"]'
        )
      : null;

    var mainPrice =
      productSection.querySelector('[data-product-price]') ||
      productSection.querySelector('.product__price') ||
      productSection.querySelector('.ProductMeta__Price');

    var footer = document.querySelector('footer');

    if (!stickyButton || !productForm) return;
/** 
    var lang = (document.documentElement.lang || 'es').slice(0, 2);
    var translations = {
      es: 'Añadir a la cesta',
      en: 'Add to cart',
      it: 'Aggiungi al carrello',
      fr: 'Ajouter au panier',
    };
    if (translations[lang]) {
      stickyButton.textContent = translations[lang];
    }
**/
    stickyButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (mainButton && !mainButton.disabled) {
        mainButton.click();
      } else if (productForm) {
        productForm.submit();
      }
    });

    if (stickyPrice && mainPrice && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        stickyPrice.innerHTML = mainPrice.innerHTML;
      });

      observer.observe(mainPrice, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      stickyPrice.innerHTML = mainPrice.innerHTML;
    }

    var state = {
      atcVisible: true,
      footerVisible: false,
    };

    function updateBar() {
      if (!state.atcVisible && !state.footerVisible) {
        sticky.classList.add('is-visible');
        sticky.setAttribute('aria-hidden', 'false');
      } else {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
      }
    }

    if ('IntersectionObserver' in window && mainButton) {
      var atcObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            state.atcVisible = entry.isIntersecting;
            updateBar();
          });
        },
        { threshold: 0.1 }
      );

      atcObserver.observe(mainButton);

      if (footer) {
        var footerObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              state.footerVisible = entry.isIntersecting;
              updateBar();
            });
          },
          { threshold: 0.01 }
        );

        footerObserver.observe(footer);
      }
    } else {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStickyATC(document);
    });
  } else {
    initStickyATC(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    initStickyATC(event.target);
  });
})();